import { HStack, AspectRatio, Image, Box, Text } from '@chakra-ui/react';
import React from 'react';
import feature1 from '@/assets/images//webp/feature-1.webp';
import feature2 from '@/assets/images//webp/feature-2.webp';
import feature3 from '@/assets/images//webp/feature-3.webp';
import feature4 from '@/assets/images//webp/feature-4.webp';
import { TFunction } from 'i18next';

export interface FeaturesProps {
  t: TFunction;
}

const DesktopFeatures: React.VFC<FeaturesProps> = ({ t }) => {
  return (
    <HStack align="flex-start" py="4" spacing="12">
      <Box textAlign="center" w="255px">
        <AspectRatio mx="auto" ratio={9 / 16} w="225px">
          <Image alt={t('3d_mapping_with_fast_map_generation')} src={feature1} />
        </AspectRatio>
        <Text mt="4">{t('3d_mapping_with_fast_map_generation')}</Text>
      </Box>
      <Box textAlign="center" w="255px">
        <AspectRatio mx="auto" ratio={9 / 16} w="225px">
          <Image alt={t('best_in_class_fast_relocalization')} src={feature2} />
        </AspectRatio>
        <Text mt="4">{t('best_in_class_fast_relocalization')}</Text>
      </Box>
      <Box textAlign="center" w="255px">
        <AspectRatio mx="auto" ratio={9 / 16} w="225px">
          <Image alt={t('content_authoring_unleashed_creativity')} src={feature3} />
        </AspectRatio>
        <Text mt="4">{t('content_authoring_unleashed_creativity')}</Text>
      </Box>
      <Box textAlign="center" w="255px">
        <AspectRatio mx="auto" ratio={9 / 16} w="225px">
          <Image alt={t('create_sharing_ar_with_multiplayer_service')} src={feature4} />
        </AspectRatio>
        <Text mt="4">{t('create_sharing_ar_with_multiplayer_service')}</Text>
      </Box>
    </HStack>
  );
};

export default DesktopFeatures;
